module.exports = __webpack_public_path__ + "img/mine.df79acfb.png";